import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import s from "./MyApplication.module.scss";
import {
  ArrowUpOutlined,
  CrownOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  FormOutlined,
  HeartOutlined,
  MessageOutlined,
  ThunderboltOutlined,
  UpCircleOutlined,
} from "@ant-design/icons";
import { message, Tooltip } from "antd";
import { useDispatch } from "react-redux";
import {
  addUrgentVipToCar,
  getCarDetails,
  getMyCars,
  upCar,
} from "../../redux/carSlice";

const MyApplication = ({ car }) => {
  const [isHovered, setIsHovered] = useState();
  const [activeIndex, setActiveIndex] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const handleDotClick = (index) => {
    setActiveIndex(index);
  };

  const success = (message) => {
    messageApi.open({
      type: "success",
      content: message,
    });
  };

  const error = (message) => {
    messageApi.open({
      type: "error",
      content: message,
    });
  };

  useEffect(() => {
    dispatch(getMyCars());
  }, [dispatch]);

  const upMyCar = async (id) => {
    const res = await dispatch(upCar(id));
    if (res.type === "cars/upCar/rejected") error(res.payload);
    if (res.type === "cars/upCar/fulfilled") success(res.payload.success);
  };

  const addUrgentVipStatusToCar = async (id, data) => {
    let params;

    if (car.urgent && data === "is_urgent") {
      params = { is_urgent: false };
      success('Вы удалили  статус "СРОЧНО"');
    } else if (car.urgent === false && data === "is_urgent") {
      params = { is_urgent: true };
      success('Вы добавили статус "СРОЧНО"');
    }

    if (car.vip && data === "is_vip") {
      params = { is_vip: false };
      success('Вы удалили статус "VIP"');
    } else if (car.vip === false && data === "is_vip") {
      params = { is_vip: true };
      success('Вы добавили статус "VIP"');
    }

    const res = await dispatch(addUrgentVipToCar({ id, params }));
    if (res.type === "cars/addUrgentVipToCar/rejected") error(res.payload);
    if (res.type === "cars/addUrgentVipToCar/fulfilled") {
      dispatch(getMyCars());
    }
  };

  return (
    <div
      className={s.carCatalogueItem}
      onClick={() => dispatch(getCarDetails(car?.id))}
    >
      {contextHolder}
      <div>
        <div
          className={s.carItem}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {car.urgent ? <div className={s.urgent}>СРОЧНО</div> : null}
          {car.vip ? (
            <div className={s.vip}>
              {" "}
              <CrownOutlined />
              &nbsp;VIP
            </div>
          ) : null}
          <div className={s.img_wrapper}>
            {<img src={car?.images[0]?.image} className={s.car_img} />}
          </div>

          {isHovered ? (
            <div className={s.hovered}>
              <div className='carousel'>
                <div
                  className='slides'
                  style={{ transform: `translateX(-${activeIndex * 100}%)` }}
                >
                  {car?.images?.map((image, index) => (
                    <div key={index} className='slide'>
                      <img src={image.image} alt={`Slide ${index + 1}`} />
                    </div>
                  ))}
                </div>
                <div className={s.dots}>
                  {car?.images?.map((_, index) => (
                    <span
                      key={index}
                      className={index === activeIndex ? "dot active" : "dot"}
                      onMouseEnter={() => handleDotClick(index)}
                    ></span>
                  ))}
                </div>
              </div>
            </div>
          ) : null}
        </div>
        <div className={s.car_info}>
          <Link
            to={`/car/${car?.id}`}
            className={s.car_info_content}
            // onClick={() => dispatch(getCarDetails(car?.id))}
          >
            <div className={s.car_name}>
              <div className={s.brand}>{car?.brand?.name}</div> &nbsp;
              <div className={s.model}>{car?.model?.name}</div>
            </div>
            <div className={s.car_price}>
              <div className={s.price_usd}>
                {Number(car?.price)?.toFixed(0)} USD
              </div>
              <div className={s.price_kgs}>
                {Number(car?.price * 90)?.toFixed(0)} KGS
              </div>
            </div>
            <div className={s.car_icons}>
              <div className={s.views}>
                <EyeOutlined className={s.icon} /> &nbsp;100
              </div>
              &nbsp;
              <div className={s.likes}>
                <HeartOutlined className={s.icon} />
                &nbsp;20
              </div>
              &nbsp;
              <div className={s.likes}>
                <MessageOutlined className={s.icon} />
                &nbsp;1
              </div>
            </div>
            <div className={s.car_text}>{car?.description}</div>
            <div className={s.bottom_btns}>
              <div className={s.location}>{"г.Бишкек"}</div>
              <div className={s.updated}>
                <ArrowUpOutlined /> {car?.up_time}
              </div>
            </div>
          </Link>
          <div className={s.panel}>
            <Link
              to={`/updateCar/${car?.id}`}
              className={s.panel_item}
              // onClick={() => dispatch(getCarDetails(car?.id))}
            >
              <Tooltip
                title={
                  <div>
                    <FormOutlined />
                    &nbsp;Редактировать
                  </div>
                }
                color={"gray"}
                placement='topRight'
              >
                <FormOutlined className={s.icon} />
              </Tooltip>
            </Link>
            <div className={s.panel_item} onClick={() => upMyCar(car.id)}>
              <Tooltip
                title={
                  <div>
                    <UpCircleOutlined />
                    &nbsp;Поднять вверх
                  </div>
                }
                color={"gray"}
                placement='topLeft'
              >
                <UpCircleOutlined className={s.icon} />
              </Tooltip>
            </div>
            <div className={s.panel_item}>
              <Tooltip
                title={
                  <div>
                    <EyeInvisibleOutlined />
                    &nbsp;Деактивировать
                  </div>
                }
                color={"gray"}
                placement='topLeft'
              >
                <EyeInvisibleOutlined className={s.icon} />
              </Tooltip>
            </div>
            <div
              className={s.panel_item}
              onClick={() => addUrgentVipStatusToCar(car.id, "is_urgent")}
            >
              <Tooltip
                title={
                  <div>
                    <ThunderboltOutlined />
                    &nbsp;Срочно
                  </div>
                }
                color={"gray"}
                placement='topLeft'
              >
                <ThunderboltOutlined className={s.icon} />
              </Tooltip>
            </div>
            <div
              className={s.panel_item}
              onClick={() => addUrgentVipStatusToCar(car.id, "is_vip")}
            >
              <Tooltip
                title={
                  <div>
                    <CrownOutlined />
                    &nbsp;VIP
                  </div>
                }
                color={"gray"}
                placement='topLeft'
              >
                <CrownOutlined className={s.icon} />
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyApplication;
